import angular from 'angular';

(function () {
  'use strict';

  angular.module('app.principal').controller('ReferentialSectionCtrl', ReferentialSectionCtrl);


  function ReferentialSectionCtrl() {
    var vm = this;

    ////////////////////////

    vm.$onInit = function () {
      vm.collapseTable = true;
    };
  }
})();
